<template>
  <div class="dashboard-container">
    <!-- <adminDashboard /> -->
    <!-- <el-button @click="fuck">123123</el-button> -->
    <!-- <component :is="currentRole" /> -->
    <div class="text">欢迎使用打卡后台管理系统</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import adminDashboard from './admin'
// import editorDashboard from './editor'

export default {
  components: { adminDashboard },
  data() {
    return {
      currentRole: 'adminDashboard'
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  mounted() {},
  methods: {
    // fuck(){
    //   this.$message.success({
    //     duration:0,
    //     message:'123123123'
    //   })
    // }
  }
}
</script>

<style scoped>
.dashboard-container {
  width: 100%;
  height: 80vh;
  position: relative;
}

.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  color: #304156;
  font-size: 32px;
}
</style>></style>
